import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from './analytics';

/**
 * Google Analytics 路由追踪组件
 * 自动追踪 react-router-dom 的路由变化
 */
function GARouteTracker() {
  const location = useLocation();

  useEffect(() => {
    // 当路由变化时追踪页面浏览
    const path = location.pathname + location.search;
    trackPageView(path);
  }, [location]);

  // 这个组件不渲染任何内容
  return null;
}

export default GARouteTracker;

